import { ConvoService } from '../../../service/ConvoService'
import TYPES from '../../../config/Types'
import { DependencyContainer } from '../../../config/DependencyContainer'

const convoService = DependencyContainer.getContainer().get<ConvoService>(TYPES.ConvoService)

const convoUtils = {
  get convoService () { return convoService },
}

export default convoUtils
